<template>
  <div class="container-fluid">

    <div class="row">
      <div class="col-md-12">
        <div class="top-title-wrap">
          <div class="main-title">
            <span>{{ $t('User Profile') }}</span>
          </div>
        </div>
        <div class="user-top-info-wrap">
          <div v-bind:class="{online: isOnline}" class="user-top-info admin-side">
            <div class="name">
              {{ userData.firstName }} {{ userData.lastName }} #{{ userData.id }}
              <a href="#" class="log-as">
                <svg width="18" height="16" viewBox="0 0 18 16" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M9.60079 11.0503L9.6008 11.0503L12.0515 8.6H1.5C1.16877 8.6 0.9 8.33123 0.9 8C0.9 7.66877 1.16877 7.4 1.49999 7.39997H1.5H12.0516L9.60089 4.94929L9.60079 11.0503ZM9.60079 11.0503C9.36629 11.2848 9.36615 11.6647 9.60088 11.8988L9.60079 11.0503ZM9.60079 4.10079C9.83485 3.86624 10.2152 3.86624 10.4492 4.10079H9.60079ZM9.60079 4.10079C9.36632 4.33526 9.36615 4.71508 9.60079 4.94919V4.10079ZM2.9 5V5.1H3H4H4.1V5V3C4.1 2.5032 4.50276 2.1 5 2.1H15C15.4972 2.1 15.9 2.5032 15.9 3V13C15.9 13.4968 15.4972 13.9 15 13.9H5C4.50273 13.9 4.1 13.4973 4.1 13V11V10.9H4H3H2.9V11V13C2.9 14.1597 3.84027 15.1 5 15.1H15C16.1597 15.1 17.1 14.1597 17.1 13V3C17.1 1.84027 16.1597 0.9 15 0.9H5C3.84027 0.9 2.9 1.84027 2.9 3V5ZM14.0696 7.99947C14.0766 7.83949 14.0235 7.6751 13.8987 7.55028L10.4493 4.10088L14.0696 7.99947Z"
                      fill="#740B99" stroke="#740B99" stroke-width="0.2"/>
                </svg>
              </a>
            </div>
            <div v-if="isOnline" class="status">{{ $t('online') }}</div>
            <div v-else class="status">{{ $t('offline') }}</div>
          </div>
          <div class="user-activity">
            <div class="item">
              <div class="name">{{ $t('Balance') }}</div>
              <div class="info">$ {{ balance | finance }}</div>
            </div>
            <div class="item">
              <div class="name">{{ $t('Campaigns') }}</div>
              <div class="info">{{ campaignsCount }}</div>
            </div>
            <div class="item">
              <div class="name">{{ $t('Creatives') }}</div>
              <div class="info">{{ creativesCount }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <box class="profile-box">
          <div class="row">
            <div class="col-md-6">
              <div class="sub-title">{{ $t('Basic Personal Info') }}</div>
              <div class="form-group full-width normal">
                <div class="row">
                  <div class="col-md-6">
                    <label class="group-title">{{ $t('First Name') }}</label>
                    <dspInput v-model="userData.firstName"
                              v-validate="'required|min:2|max:255'"
                              :errorsBag="errors"
                              name="firstName"/>
                  </div>
                  <div class="col-md-6">
                    <label class="group-title">{{ $t('Last Name') }}</label>
                    <dspInput v-model="userData.lastName"
                              v-validate="'required|min:2|max:255'"
                              :errorsBag="errors"
                              name="lastName"/>
                  </div>
                </div>
              </div>
              <div class="form-group full-width normal">
                <label class="group-title">{{ $t('E-mail') }}</label>
                <dspInput v-model="email"
                          v-validate="'required|email'"
                          :errorsBag="errors"
                          :isDisabled="this.$route.params.id!=='create'"
                          name="email"/>
              </div>

              <div class="form-group full-width">
                <label class="group-title">{{ $t('Company') }}</label>
                <dspInput v-model="userData.company"
                          v-validate="'required|min:2|max:255'"
                          :errorsBag="errors"
                          name="company"/>
              </div>
            </div>
            <div class="col-md-6">
              <div class="sub-title">{{ $t('Global User Settings') }}</div>
              <div class="form-group full-width normal">
                <div class="row">

                </div>
              </div>
              <div class="form-group full-width normal">
                <div class="row">
                  <div class="col-md-4 ">
                    <label class="group-title">{{ $t('User Markup Rate') }}</label>
                    <dspInput v-model="calcMarkup"
                              class="no-wrap"
                              v-validate="'percent'"
                              :errorsBag="errors"
                              name="agencyMarkup"/>
                  </div>

                </div>
              </div>

            </div>

          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group full-width normal" v-for="(permission,index) in  this.permissionsList" :key="index">
                <dspCheckbox
                    :isChecked="userData.permissions.includes(permission.name)"
                    v-validate="''"
                    :errorsBag="errors"
                    :inpLabel="permission.displayName"
                    @change="changePermission(permission.name,$event)"
                    name="isMalwareAdvert"
                />
              </div>
            </div>
          </div>
          <div v-if="$route.params.id!=='create'" class="btn-wrap left">
            <div class="del-dropdown">
              <b-dropdown right :text="$t('Delete')" variant="danger">
                <b-button-group vertical>
                  <b-button variant="danger" v-b-modal.modal-approve>{{
                      $t('Just Delete')
                    }}
                  </b-button>
                  <b-button variant="danger" @click="deleteAndWipeUserModal()">
                    {{ $t('Delete and wipe personal data') }}
                  </b-button>
                </b-button-group>
              </b-dropdown>
            </div>
          </div>
          <div class="btn-wrap">
            <a class="button plain" @click="$router.go(-1)">{{ $t('Cancel') }}</a>
            <dspButton :disabled="errorsExists" @click="saveUserData" class="primary">{{
                $t('Save')
              }}
            </dspButton>
          </div>
        </box>
      </div>
    </div>
    <b-modal ref='modal' id="modal-approve">
      <div class="approve-text">
        {{ $t(' You’re about to delete user') }}<br>
        <template v-if="wipePersonalInfo">{{ $t('And remove all user personal data') }}</template>
        <br>
        <span>{{ userData.firstName }} {{ userData.lastName }}</span>.<br> {{ $t('Are you sure?') }}

      </div>
      <div slot="modal-footer">
        <dspButton v-on:click="$bvModal.hide('modal-approve'); wipePersonalInfo=0" class="plain">{{
            $t('Cancel')
          }}
        </dspButton>
        <dspButton v-on:click="deleteUser" class="danger">{{ $t('Delete') }}</dspButton>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {parse, percentFormatter} from "@/lib/numberFormatters";

export default {
  name: 'UserEdit',

  data: function () {
    return {
      campaignsCount: 0,
      creativesCount: 0,

      userStatusList: [this.$t('Active'), this.$t('Disabled')],
      userData: {
        id: '',
        role: '',
        firstName: '',
        lastName: '',
        emailSpare: '',
        company: '',
        country: '',
        address: '',
        phone: '',
        firstPaymentAmount: 0,
        followingPaymentAmount: 0,
        minBalanceNotification: 0,
        agencyMarkup: 0,
        ivtPx: 10,
        useUnscanned: 1,
        autoApprovePayments: false,
        allowRefill: false,
        prepay: false,
        canSeeClick: true,
        canSeeSsp: false,
        canSeeSspPremium: false,
        isCannabisAdvert: false,
        isGamblingAdvert: false,
        isMalwareAdvert: false,
        isPremiumAdvert: false,
        isMinPriceCancellation: false,
        attachedSales: 0,
        attachedAccount: 0,
      },
      isOnline: false,
      balance: 0,
      email: '',
      wipePersonalInfo: 0,

      sortDesc: true,
      pagination: {
        currentPage: 1,
        perPage: 15,
        totalRows: 0,
      },
      checkPretarget: 0,


      searchText: "",
      filter: "",
      filters: ["ID"],
      permissionsList:[],
    }
  },

  //     calcFirstPaymentAmount: {
  //         get: function () {
  //             return currencyFormatter(this.userData.firstPaymentAmount);
  //         },
  //         set(val) {
  //             this.userData.firstPaymentAmount = parse(val);
  //             this.$nextTick(() => {
  //                 this.$validator.validate('firstPaymentAmount', val);
  //             });
  //         }
  //     },
  //     sortByPretarget: 'campaignId',
  //     sortDesc: true,
  //     pagination: {
  //         currentPage: 1,
  //         perPage: 15,
  //         totalRows: 0,
  //     },
  //     checkPretarget: 0,
  //     countryList: [],
  //     userStatusList: [this.$t('Active'), this.$t('Disabled')],
  //     userData: {
  //         id: '',
  //         role: '',
  //         firstName: '',
  //         lastName: '',
  //         emailSpare: '',
  //         company: '',
  //         country: '',
  //         address: '',
  //         phone: '',
  //         firstPaymentAmount: 0,
  //         followingPaymentAmount: 0,
  //         minBalanceNotification: 0,
  //         markup: 0,
  //         ivtPx: 10,
  //         useUnscanned: 10,
  //         autoApprovePayments: false,
  //         allowRefill: false,
  //         prepay: false,
  //         canSeeClick: true,
  //         canSeeSsp: false,
  //         canSeeSspPremium: false,
  //         isCannabisAdvert: false,
  //         isGamblingAdvert: false,
  //         isMalwareAdvert: false,
  //         isPremiumAdvert: false,
  //         isMinPriceCancellation: false,
  //     },
  //     isOnline: false,
  //     balance: 0,
  //     email: '',
  //     password: '',
  //     passwordСonfirmation: '',
  //     wipePersonalInfo: 0,
  //     pretargetingItems: [
  //         {campaign: "2Campaign name", pretargeting: "", link: ""},
  //         {campaign: "3Campaign name", pretargeting: "", link: ""},
  //         {campaign: "1Campaign name", pretargeting: "", link: ""},
  //         {campaign: "1Campaign name", pretargeting: "", link: ""},
  //         {campaign: "Campaign name", pretargeting: "Pretargeting name", link: "#"},
  //     ],
  //     pretargetingFields: [
  //
  //         {key: "campaignName", label: this.$t("Campaign"), sortable: false},
  //         {key: "pretargetName", label: this.$t("Pretargeting"), sortable: false},
  //         {key: "actions", label: ""},
  //     ],
  //     searchText: "",
  //     filter: "",
  //     filters: ["ID"],
  //     pretargetingList: [],
  // }
  // },
  watch: {

  },
  computed: {
    calcMarkup: {
      get: function () {
        return percentFormatter(this.userData.agencyMarkup);
      },
      set(val) {
        this.userData.agencyMarkup = parse(val.replace(/%/, ''));
        this.$nextTick(() => {
          this.$validator.validate('agencyMarkup', val);
        });
      }
    },
    errorsExists() {
      return this.errors.items.length ? true : false;
    },
  },

  created() {
    this.getUserData();
    this.getPermissionsList();
  },

  mounted() {
    this.$validator.localize({
      en: {
        attributes: {
          'password_confirmation': 'password confirmation',
        }
      },
    });
  },

  methods: {
    changePermission(permission,event){
      if (event){
        this.userData.permissions.push(permission);
      }else{
        const index = this.userData.permissions.indexOf(permission);
        if (index > -1) {
          this.userData.permissions.splice(index, 1);
        }
      }
    },
    getPermissionsList(){
      this.axios.get('get-permissions-list').then(resp=>{
        this.permissionsList=resp.data;
      });
    },
    getUserData() {
      let id = this.$route.params.id;

      if (id === 'create') {
        return;
      }

      this.$axios.get('/users/' + id + '?append=campaignsCount;creativesCount')
          .then(response => {
            this.userData = {
              id: response.data.data.id,
              firstName: response.data.data.firstName,
              lastName: response.data.data.lastName,
              company: response.data.data.company,
              agencyMarkup: response.data.data.agencyMarkup,
              permissions: response.data.data.permissions,
            };

            this.email = response.data.data.email;
            this.balance = response.data.data.balance;
            this.isOnline = response.data.data.isOnline;
            this.campaignsCount = response.data.data.campaignsCount;
            this.creativesCount = response.data.data.creativesCount;
          })
          .catch(error => {
            this.$backendErrors(error, this.$t('Error'));
          });
    },

    saveUserData() {
      this.$validator.validateAll().then(valid => {
        if (!valid) return false;

        let data = this.userData;

        if (this.password) {
          data['password'] = this.password;
          this.password = '';
          data['password_confirmation'] = this.passwordСonfirmation;
          this.passwordСonfirmation = '';
        }

        data['fromUserPage'] = true;
        let id = this.$route.params.id;

        if (id === 'create') {
          data['email'] = this.email;

          this.$axios
              .post('/users', data)
              .then(response => {
                this.password = '';
                this.passwordСonfirmation = '';

                this.$router.push({name: 'admin.user.edit', params: {id: response.data.data.id}});

                this.$notify.info(this.$t('User created'));
              })
              .catch(error => {
                this.$backendErrors(error, this.$t('Error save user: '), this.$validator, '');
              });

          return;
        }

        this.$axios
            .patch('/users/' + id, data)
            .then(() => {
              this.$notify.info(this.$t('User data updated'));
            })
            .catch(error => {
              this.$backendErrors(error, this.$t('Error save user: '), this.$validator, '');
            });
      });
    },

    deleteAndWipeUserModal() {
      this.wipePersonalInfo = 1;
      this.$refs.modal.show();
    },

    deleteUser() {

      const params = {wipePersonalInfo: this.wipePersonalInfo};

      this.$axios
          .delete('/users/' + this.$route.params.id, {params: params})
          .then(() => {
            this.$router.push({name: 'admin.users'});

            this.$notify.info('User deleted');
          })
          .catch(error => {
            this.$backendErrors(error, this.$t('Error delete user: '), this.$validator, '');
          });

      this.$bvModal.hide('modal-approve');
    },
  }
}
</script>

<style lang="scss">
.modal-content {
  padding-top: 0;

  .footer-modal {
    border: none;
    box-shadow: none;

    .btn:first-child {
      background-color: white;
      color: #740B99;
      border: none;
      font-weight: 400;
      font-size: 12px;
    }

    .btn:last-child {
      background-color: #740B99;
      border: none;
      font-weight: 400;
      font-size: 12px;
      padding: 0.813rem 2.75rem;
    }
  }

  .delete-btn {
    background: url(../images/cross-close.svg) 50% 50% no-repeat;
    cursor: pointer;
    height: 0.875rem;
    width: 0.875rem;
  }

  .modal-header {
    padding: 1.858rem 0 0.688rem 1.25rem;
  }
}

.del-dropdown {
  .dropdown {
    .dropdown-menu {
      padding: 0;
    }

    .btn {
      min-width: 100px;
      padding-left: 10px;
      padding-right: 10px;
      padding-top: 7px;
      padding-bottom: 6px;
      box-sizing: border-box;
      border-radius: 5px;
      text-align: center;
      cursor: pointer;
      -webkit-transition: border-color 400ms;
      transition: border-color 400ms;
      outline: none !important;
      font-size: 12px !important;
      line-height: 20px !important;
      display: inline-block;
      text-decoration: none;
    }

    .btn-danger {
      background: linear-gradient(180deg, #E33719 0%, #D63418 100%);

    }

    .dropdown-item {
      min-width: 100px;
      padding-left: 10px;
      padding-right: 10px;
      padding-top: 7px;
      padding-bottom: 6px;
      box-sizing: border-box;
      border-radius: 5px;
      text-align: center;
      cursor: pointer;
      -webkit-transition: border-color 400ms;
      transition: border-color 400ms;
      outline: none !important;
      font-size: 12px !important;
      line-height: 20px !important;
      display: inline-block;
      text-decoration: none;

      &.text-danger {
        background: linear-gradient(180deg, #E33719 0%, #D63418 100%);
        color: #FFF;
      }

    }
  }
}

.admin-user-markup-wrap {
  padding-top: 29px;

  .check-wrap {
    padding-left: 36px;

    &:first-child {
      padding-left: 0;
    }
  }
}

#modal-approve {
  .modal-dialog {
    max-width: 297px;
    min-height: calc(100% - 3.5rem);
    display: flex;
    align-items: center;

    .modal-header {
      display: none;
    }

    .approve-text {
      padding-top: 20px;
      padding-bottom: 20px;
      text-align: center;
      font-size: 16px;
      line-height: 24px;

      span {
        color: #740B99;
      }
    }

    .modal-footer {
      width: 100%;
      justify-content: center;
    }
  }
}


#data-table-pretarget {
  &.b-table {
    tr {
      td {
        white-space: normal;
      }
    }
  }

}

</style>

<style lang="scss" scope="scoped">
@import '@/scss/components/form-group';

.user-top-info-wrap {
  margin-top: 16px;
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
}

.user-top-info {
  padding: 14px 70px 14px 40px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  background: #fff;
  display: inline-flex;
  flex-direction: column;
  margin-right: 30px;
  position: relative;

  &.admin-side {
    .name {
      padding-right: 26px;

      .log-as {
        position: absolute;
        right: 0;
        top: 2px;

        svg {
          width: 16px;
        }
      }
    }
  }

  .name {
    position: relative;
    font-size: 20px;
    line-height: 28px;

    &:before {
      content: '';
      position: absolute;
      width: 6px;
      height: 6px;
      background: #637381;
      border-radius: 50%;
      top: 14px;
      left: -22px;
    }
  }

  &.online {
    .name {
      &:before {
        background: #4BDA95;
      }
    }
  }

  .status {
    font-size: 12px;
    line-height: 28px;
    color: #637381;
  }
}

.user-activity {
  display: flex;
  flex-direction: row;

  .item {
    padding: 15px;
    min-width: 140px;
    background: #F6F6F8;
    box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.06);
    border-radius: 5px;
    margin-left: 10px;

    &:first-child {
      margin-left: 0;
    }

    .name {
      font-size: 12px;
      line-height: 20px;
      color: #637381;
    }

    .info {
      font-size: 18px;
      line-height: 24px;
      font-weight: 500;
      font-family: 'Epilogue';
    }
  }
}

@include profile-form-group;

.profile-box {
  padding: 20px 20px 80px 20px;
  max-width: 1070px;
  position: relative;

  .sub-title {
    padding-top: 4px;
    padding-bottom: 22px;
    font-size: 16px;
    line-height: 24px;
    font-family: 'Epilogue';
  }

  .help-link2 {
    display: inline-block;

    font-size: 12px;
    line-height: 20px;
    color: #740B99;
  }

  .btn-wrap {
    padding: 20px;
    position: absolute;
    right: 0;
    bottom: 0;
    background: #FFFFFF;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
    border-radius: 3px;

    &.left {
      right: auto;
      left: 0;
      display: flex;
    }
  }
}
</style>
